/**
 * ConnectLocallyDrawer — right-side drawer that surfaces the canary-cli
 * connect steps from any tab on the sandbox detail page. Triggered by the
 * "Connect locally" button in the header.
 */
import React from 'react';
import { Drawer, DrawerTrigger, Text } from '@chatsdet/ui';
import { Terminal } from '@phosphor-icons/react';
import { ConnectSteps } from './ConnectSteps';

export interface ConnectLocallyDrawerProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  instanceId: string;
}

export function ConnectLocallyDrawer({
  isOpen,
  onOpenChange,
  instanceId,
}: ConnectLocallyDrawerProps) {
  return (
    <DrawerTrigger
      isOpen={isOpen}
      onOpenChange={onOpenChange}
      className="max-w-[440px]"
    >
      <span />
      <Drawer title="Connect to this sandbox locally" hideCloseButton={false}>
        <div className="p-5">
          <Text className="text-muted-foreground text-sm mb-5 inline-flex items-center gap-2">
            <Terminal size={14} weight="fill" className="text-primary shrink-0" />
            Drive this sandbox from your terminal — richer than the in-browser chat.
          </Text>
          <ConnectSteps instanceId={instanceId} />
          <div className="mt-6 pt-4 border-t border-border text-[11px] text-muted-foreground">
            Need help?{' '}
            <a
              href="https://docs.canary.dev/guides/running-tests-with-cli"
              target="_blank"
              rel="noopener noreferrer"
              className="text-primary hover:underline"
            >
              Read the CLI guide →
            </a>
          </div>
        </div>
      </Drawer>
    </DrawerTrigger>
  );
}

ConnectLocallyDrawer.displayName = 'ConnectLocallyDrawer';
